export class GetCaseStudiesRequest {
    constructor(
        public key: string = "getCaseStudies",
    ) { }

}